import { render } from "./AnnotationSuggestion.vue?vue&type=template&id=2d14199d"
import script from "./AnnotationSuggestion.vue?vue&type=script&lang=js"
export * from "./AnnotationSuggestion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__